import React from 'react'
import PropTypes from 'prop-types'
import { FormattedMessage } from 'react-intl'
import Button from 'src/Components/Button'

const propTypes = {
  href: PropTypes.string.isRequired,
  zipcode: PropTypes.string.isRequired,
  className: PropTypes.string
}

const ListingsButton = ({ href, zipcode, ...restProps }) => (
  <Button
    element='a'
    target='_blank'
    rel='noopener noreferrer'
    href={href}
    {...restProps}
  >
    <FormattedMessage
      id='Button.viewListings'
      defaultMessage='View all {zipcode} listings'
      values={{ zipcode }}
    />
  </Button>
)

ListingsButton.propTypes = propTypes

export default ListingsButton
